export function intersect<TValue>(left: Set<TValue>, right: Set<TValue>): Set<TValue> {
    return new Set([...left].filter((x) => right.has(x)));
}
